(function () {
  if (typeof Swiper === 'undefined') return;
  var el = document.querySelector('.cozy-pdp--gallery--thumbs');
  if (!el || el.classList.contains('swiper-initialized')) return;

  new Swiper(el, {
    wrapperClass: 'cozy-pdp--gallery--thumbs--wrapper',
    slideClass: 'cozy-pdp--thumb',
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: false,
    navigation: {
      nextEl: '.cozy-pdp--thumb--next',
      prevEl: '.cozy-pdp--thumb--prev',
      disabledClass: 'disabled',
    },
    breakpoints: {
      1024: {
        direction: 'vertical',
        spaceBetween: 0,
      },
    },
  });

  var mainImage = document.getElementById('cozy-pdp-gallery-main');
  var thumbs = document.querySelectorAll('.cozy-pdp--thumb');
  if (!mainImage || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      mainImage.src = full;
      thumbs.forEach(function (t) { t.classList.remove('selected'); });
      thumb.classList.add('selected');
    });
  });
})();

(function () {
  function equalizeSwatchLabels() {
    document.querySelectorAll('.cozy-pdp--variant-picker fieldset').forEach(function (fieldset) {
      var names = fieldset.querySelectorAll('.cozy-pdp--option-name');
      if (names.length < 2) return;

      names.forEach(function (name) { name.style.width = ''; });

      var namesExceptLast = Array.prototype.slice.call(names, 0, names.length - 1);
      var maxWidth = 0;
      namesExceptLast.forEach(function (name) {
        maxWidth = Math.max(maxWidth, name.offsetWidth);
      });

      namesExceptLast.forEach(function (name) {
        name.style.width = maxWidth + 'px';
      });
    });
  }

  equalizeSwatchLabels();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(equalizeSwatchLabels);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeSwatchLabels, 200);
  });
})();

(function () {
  var items = document.querySelectorAll('.cozy-pdp--accordion--item');
  if (!items.length) return;

  items.forEach(function (item) {
    var header = item.querySelector('.cozy-pdp--accordion--header');
    if (!header) return;
    header.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  });
})();

(function () {
  // Accordion headings come straight from whatever the merchant typed in
  // the theme editor (e.g. "DESCRIPTION", "Description", "description").
  // We keep that text untouched in the admin/data, but always *display* it
  // in a consistent Title Case to match the design, regardless of how it
  // was entered.
  var headings = document.querySelectorAll('.cozy-pdp--accordion--heading');
  headings.forEach(function (el) {
    var text = el.textContent;
    if (!text) return;
    el.textContent = text.toLowerCase().replace(/(^|\s)\S/g, function (match) {
      return match.toUpperCase();
    });
  });
})();

(function () {
  // The quantity select lives outside the product form (associated only via
  // the `form` attribute) so it can visually sit next to the real Add to
  // cart button. That button (and any extra buttons, e.g. Customily's own
  // "Preview" button) are rendered inside buy-buttons.liquid, and apps like
  // Customily inject their own fields/buttons into the same form
  // asynchronously and in an order we don't control - so we just make sure
  // the quantity row ends up inside that button row, and let CSS `order`
  // handle the actual visual arrangement regardless of DOM order/timing.
  var wrap = document.querySelector('.cozy-pdp--add-to-cart-wrap');
  var qtyRow = document.querySelector('.cozy-pdp--qty-row');
  if (!wrap || !qtyRow) return;

  var moved = false;

  function moveQty() {
    if (moved) return;
    var submitBtn = wrap.querySelector('.product-form__submit');
    var buttonsRow = submitBtn && submitBtn.parentElement;
    if (!submitBtn || !buttonsRow) return;

    buttonsRow.classList.add('cozy-pdp--buttons-row');
    buttonsRow.appendChild(qtyRow);
    moved = true;
    observer.disconnect();
  }

  var observer = new MutationObserver(moveQty);
  observer.observe(wrap, { childList: true, subtree: true });

  moveQty();
  setTimeout(moveQty, 3000);
})();

(function () {
  // Quantity: dropdown with the first 10 values; picking "10+" swaps it for a
  // number input (only one of them is enabled, so only one `quantity` is sent).
  // The product form is `novalidate`, so keep the typed value valid ourselves:
  // empty/invalid -> min, clamp to min/max, snap to step.
  var select = document.querySelector('select.cozy-pdp--qty');
  var input = document.querySelector('.cozy-pdp--qty-input');
  if (!select || !input) return;

  select.addEventListener('change', function () {
    if (select.value !== 'more') return;

    select.hidden = true;
    select.disabled = true;
    input.hidden = false;
    input.disabled = false;
    input.id = select.id;
    select.removeAttribute('id');
    input.focus();
    input.select();
  });

  function normalize() {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10);
    var step = parseInt(input.step, 10) || 1;
    var value = parseInt(input.value, 10);

    if (isNaN(value) || value < min) value = min;
    if (!isNaN(max) && value > max) value = max;
    value = min + Math.round((value - min) / step) * step;
    if (!isNaN(max) && value > max) value -= step;

    input.value = value;
  }

  input.addEventListener('change', normalize);
  input.addEventListener('blur', normalize);
  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') normalize();
  });
})();
